import axios from "axios";
import Constant from "@/utils/constants";
import constants from "@/utils/constants";
export async function getAllJuz() {
  var listJuz;
  const response = await axios

    .get(Constant.QORANI + "juz/getall")
    .then((response) => {
      listJuz = response.data;
    });

  return listJuz;
}
export async function getAllHizb() {
  var listHizb;
  const response = await axios
    .get(Constant.QORANI + "hizb/getall")
    .then((response) => {
      listHizb = response.data;
    });

  return listHizb;
}
export async function getAllSurat() {
  var listSurat;
  const response = await axios
    .get(Constant.QORANI + "surat/getall")
    .then((response) => {
      listSurat = response.data;
    });
  console.log(listSurat);

  return listSurat;
}
export async function getAllTheme() {
  var listTheme;
  const response = await axios
    .get(Constant.QORANI + "theme/getall")
    .then((response) => {
      listTheme = response.data;
    });

  return listTheme;
}

export async function getAllduaa() {
  var listDuaa;
  const response = await axios
    .get(Constant.QORANI + "duaa/getall")
    .then((response) => {

      listDuaa = response.data;
    });
  console.log(listDuaa);

  return listDuaa;
}
export async function getAllVerset() {
  var listVerset;
  const response = await axios
    .get(Constant.QORANI + "verset/getall")
    .then((response) => {
      listVerset = response.data;
    });

  return listVerset;
}
export async function getAllVersetWithPagination(page, size) {
  const body = {};
  body.page = page;
  body.size = size;
  const response = await fetch(Constant.QORANI + "verset/getallPaginateAdmin", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
  return response.json();
}
export async function getAllVersetBySurate(SuratId) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}verset/getBySurateAdmin/${SuratId}`
    );
    const listVersetBySurate = response.data;
    return listVersetBySurate;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}
export async function getBySurateAdminSpecifique(SuratId) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}verset/getBySurateAdminSpecifique/${SuratId}`
    );
    const listVersetBySurate = response.data;
    return listVersetBySurate;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}



export async function getListVersetStartTime(recitateurId, listVersetId) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}verset/getBySurateAdmin/${SuratId}`
    );
    const listVersetBySurate = response.data;
    return listVersetBySurate;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}

export async function getAllJuzz() {
  var listJuzz;
  const response = await axios
    .get(Constant.QORANI + "juz/getall")
    .then((response) => {
      listJuzz = response.data;
    });

  return listJuzz;
}
export async function getAllProphete() {
  var listProphete;
  const response = await axios
    .get(Constant.QORANI + "prophete/getall")
    .then((response) => {
      listProphete = response.data;
    });

  return listProphete;
}
export async function getAllRecitateur() {
  var listRecitateur;
  const response = await axios
    .get(Constant.QORANI + "recitateur/getall")
    .then((response) => {
      listRecitateur = response.data;
      console.log(response);

    });
  return listRecitateur;
}
export async function getAllAuthor() {
  var listAuthor;
  const response = await axios
    .get(Constant.QORANI + "authorCertificate/getall")
    .then((response) => {
      listAuthor = response.data;
    });
  return listAuthor;
}
export async function getAllExpert() {
  var expertList;
  const response = await axios.get(`${constants.QORANI}expert/getall`).then((res) => {
    console.log(res.data);

    expertList = res.data
  })
  return expertList
}

export async function getAllActualityCategory() {
  var listActualityCategory;
  const response = await axios
    .get(Constant.QORANI + "actualityCategory/getall")
    .then((response) => {
      listActualityCategory = response.data;
    });

  return listActualityCategory;
}
export async function getActualityByCategory(category) {
  var listActuality = [];
  let page = 0;
  let nbrTotalPage = 1;

  while (page < nbrTotalPage) {
    const response = await axios.get(Constant.QORANI + "actuality/v2/getByCategoryId/" + category + "/page/" + page)
    const data = response.data;
    listActuality.push(...data.actualityMultiTypes);
    nbrTotalPage = data.nbrTotalPage;
    page++;
  }

  return listActuality
}

export async function getAllActuality() {
  var listActuality;
  const response = await axios
    .get(Constant.QORANI + "actuality/getall")
    .then((response) => {
      console.log(response);

      listActuality = response.data;
    });

  return listActuality;
}

export async function getAllPage() {
  var listPage;
  const response = await axios
    .get(Constant.QORANI + "page/getall")
    .then((response) => {
      console.log(response);

      listPage = response.data;
    });

  return listPage;
}

export async function getAllActualityDescItem(id) {
  var listActualityDescItem;
  const response = await axios
    .get(Constant.QORANI + "actuality/get/" + id)
    .then((response) => {
      listActualityDescItem = response.data;
    });

  return listActualityDescItem.actualityDescItemResponseList;
}
export async function getAllUserstByRole(Role, page) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}user/getByRole/${Role}/${page}`
    );
    const listUserstByRole = response.data;
    return listUserstByRole;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}
export async function getAllVersetGroupe() {
  var VersetGroupe;
  const response = await axios
    .get(Constant.QORANI + "versetGroup/getall")
    .then((response) => {
      VersetGroupe = response.data;
    });

  return VersetGroupe;
}
export async function getVersetGroupeById(VersetGroupeId) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}versetGroup/get/${VersetGroupeId}`
    );
    const VersetGroupe = response.data;
    return VersetGroupe;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}
export async function getSouratById(SouratId) {
  try {
    const response = await axios.get(`${Constant.QORANI}surat/get/${SouratId}`);
    const surat = response.data;
    return surat;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}

export async function getRecitateurById(RecitateurId) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}recitateur/get/${RecitateurId}`
    );
    const recitateur = response.data;
    return recitateur;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}
export async function getThemeById(themeId) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}theme/get/${themeId}`
    );
    const recitateur = response.data;
    return recitateur;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}
export async function getActualiteById(actualityId) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}actuality/get/${actualityId}`
    );
    const recitateur = response.data;
    return recitateur;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}
export async function getDuaaById(duaaId) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}duaa/get/${duaaId}`
    );
    const recitateur = response.data;
    return recitateur;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}

export async function getPage(id) {
  try {
    const response = await axios.get(`${Constant.QORANI}page/get/${id}`)
    return response.data
  } catch (error) {
    console.error("An error occurred:", error);
    throw error

  }
}

export async function getPages() {
  try {
    const response = await axios.get(`${Constant.QORANI}page/getall`)
    return response.data
  } catch (error) {
    console.error("An error occurred:", error);
    throw error

  }
}

export async function getPropheteNameById(id, PropheteArray) {
  return PropheteArray.find((prophete) => prophete.id === id);
}
export async function SearchByKeyWord(key) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}user/findByKeyword/${key}`
    );
    const listUserstByRole = response.data;

    return listUserstByRole;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}

export async function SearchUserById(userId) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}user/getAllUserById/${userId}`
    );
    const listUserstByRole = response.data;

    return listUserstByRole;
  } catch (error) {
    console.error("An error occurred:", error);
    throw error;
  }
}

export async function FetchAllTags() {
  try {
    const response = await axios.get(`${Constant.QORANI}tag/getAll`);
    return response.data;
  } catch (error) {
    console.error("An error occurred while fetching tags:", error);
    throw error;
  }
}
export async function FetchAllSubCategories({ details = true } = {}) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}actualitySubCategory/getall`
    );

    const allSubCategories = response.data;
    if (details) {
      return await Promise.all(
        allSubCategories.map(async (el) => {
          const category = await axios.get(
            `${Constant.QORANI}actualityCategory/get/${el.actualityCategoryId}`
          );

          return {
            ...el,
            actualityCategory: category.data.label,
          };
        })
      );
    } else {
      return allSubCategories;
    }
  } catch (error) {
    console.error(
      "An error occurred while fetching sub categories:",
      error
    );
    throw error;
  }
}
export async function FetchSubCategoryById(id) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}actualitySubCategory/get/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("An error occurred while fetching sub category:", error);
    throw error;
  }
}
export async function FetchAllSubCategoriesByCategoryId(actualityCategoryId) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}actualitySubCategory/getAllByActualityCategoryId/${actualityCategoryId}`
    );
    const allSubCategories = response.data;
    return allSubCategories;
  } catch (error) {
    console.error(
      "An error occurred while fetching sub categories:",
      error
    );
    throw error;
  }
}
export async function FetchAllComingSoon() {
  try {
    const response = await axios.get(`${Constant.QORANI}comingSoon/getAll`);
    return response.data;
  } catch (error) {
    console.error("An error occurred while fetching coming soon items:", error);
    throw error;
  }
}
export async function FetchActualityByCategoryAndSubCategory(category, subCategoryId) {
  try {
    const response = await axios.get(
      `${Constant.QORANI}actuality/getByCategoryId/${category}/AndSubCategory/${subCategoryId}/page/0`
    );
    return response.data;
  }
  catch (error) {
    console.error("An error occurred while fetching actuality by category and subcategory:", error);
    throw error;
  }
}
export async function FetchActualityWithoutSubCategory() {
  try {
    const response = await axios.get(
      `${Constant.QORANI}actuality/getActualityWithoutSubCategory`
    );
    return response.data;
  }
  catch (error) {
    console.error("An error occurred while fetching actuality without subcategory:", error);
    throw error;
  }
}

